var path = 'msi/shipments/change-shipment-date/views/change-shipment-date-button.html';
var html = "<button type=\"button\" ng-click=\"$ctrl.openDateSelectModal()\">\n  {{'SHIPMENT_CHANGE_DATE_BUTTON' | translate}}\n</button>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;